import * as angular from 'angular';
import { ComponentDefinition } from '../../models';

class AdministrationContainerStateController implements angular.IComponentController {
    static $inject = [
    ];
}

export const wtAdministrationContainerState: ComponentDefinition = {
    componentId: 'wtAdministrationContainerState',
    controller: AdministrationContainerStateController,
    template: require('./administrationContainerState.component.html'),
    controllerAs: 'vm',
    bindings: {}
};